export default "__VITE_ASSET__DAdENVT$__"